angular
  .module('session', ['ngResource', 'ngRoute'])
  .config(function () {})
  .factory('Session', ['$resource', function ($resource) {
    var Session = $resource(
      CONFIG.api('session'),
      {},
      {
        get: {method: 'GET', params: {action: 'get'}},
        set_persistent_data: {method: 'POST', params: {action: 'set_persistent_data'}},
      },
    )
    return Session
  }])

// This is used by the top bar
angular.module('session').controller('SessionCtrl', ['$scope', '$rootScope', '$location', 'Session', function ($scope, $rootScope, $location, Session) {
  // this route does not need a session
  if ($location.path().indexOf('edit_me_h') > 0) {
    $rootScope.session.get_persistent_data = function () {}
  } else {
    $rootScope.session.get_persistent_data = function (key) {
      return $rootScope.session.user.persistent_data[key]
    }

    $rootScope.session.set_persistent_data = function (key, val) {
      $rootScope.session.user.persistent_data[key] = val
      Session.set_persistent_data({key: key, val: val})
    }
  }
}])
